import { z } from 'zod';
/**
 * «Mi perfil»: lo que cada persona ve y cambia de su ficha en SGDEA (`/me/...`). La cuenta (contraseña, verificación en
 * dos pasos) es de la suite Datalog (GUIA-AGENTES §3.7).
 */
/** Avisos internos que también pueden llegar por correo (los mismos `type` de `NotificationsService`). */
export const NOTIFICATION_TYPES = [
    { type: 'NEW_TASK', label: 'Nueva tarea asignada' },
    { type: 'TASK_REASSIGNED', label: 'Tarea reasignada' },
    { type: 'UNASSIGNED_TASK', label: 'Tarea sin responsable' },
    { type: 'UNASSIGNED_CASE', label: 'Caso sin asignar' },
    { type: 'SLA_WARNING', label: 'Término por vencer' },
    { type: 'SLA_BREACH', label: 'Término vencido' },
    { type: 'SLA_ESCALATION', label: 'Escalamiento por término' },
    { type: 'ESCALATION', label: 'Escalamiento' },
    { type: 'CITIZEN_REPLY', label: 'Respuesta del ciudadano' },
    { type: 'COURT_REPLY', label: 'Comunicación del juzgado' },
    { type: 'SUPPORT_REQUESTED', label: 'Solicitud de apoyo para tu área' },
    { type: 'SUPPORT_ANSWERED', label: 'Respuesta a una solicitud de apoyo' },
    { type: 'SUPPORT_CANCELLED', label: 'Solicitud de apoyo cancelada' },
    { type: 'AREA_TRANSFER_REQUESTED', label: 'Solicitud de traslado de área por aprobar' },
    { type: 'AREA_TRANSFER_DECIDED', label: 'Traslado de área aprobado o rechazado' },
    { type: 'AREA_TRANSFER_CANCELLED', label: 'Solicitud de traslado de área cancelada' },
    { type: 'REOPEN_REQUESTED', label: 'Solicitud de reapertura por aprobar' },
    { type: 'REOPEN_DECIDED', label: 'Reapertura aprobada o rechazada' },
    { type: 'REOPEN_CANCELLED', label: 'Solicitud de reapertura cancelada' },
    { type: 'WORKFLOW', label: 'Avisos del proceso' },
    { type: 'SETUP_ATTENTION', label: 'Puesta en marcha' },
    { type: 'EMAIL_FAILED', label: 'Correo al ciudadano no enviado' },
];
/** Columnas visibles de una tabla, en su orden (claves de la tabla, como `inbox` o `archive`). */
export const tablePreferenceSchema = z.object({ columns: z.array(z.string().max(60)).max(60) });
/** Preferencias de la persona (`users.preferences`): avisos por correo por tipo, atajos de teclado y columnas de cada tabla. */
export const userPreferencesSchema = z.object({
    shortcuts: z.boolean().optional(),
    notifications: z.record(z.object({ email: z.boolean() })).optional(),
    /** Por clave de tabla; el cliente manda el objeto completo (el servidor reemplaza la clave `tables` entera). */
    tables: z.record(z.string().max(40), tablePreferenceSchema).optional(),
});
/** Lo que la persona cambia de sí misma: sus preferencias. Nombre, cargo, áreas y disponibilidad los fija un administrador. */
export const updateProfileSchema = z.object({
    preferences: userPreferencesSchema.optional(),
});
/**
 * Cómo firma la persona sus respuestas: `TEXT`, su nombre y cargo; `IMAGE`, la imagen de su firma manuscrita sobre
 * el nombre y el cargo. La firma electrónica (código de la app o del correo) es la misma en los dos casos.
 */
export const SIGNATURE_STYLES = ['TEXT', 'IMAGE'];
export const signatureStyleSchema = z.object({ style: z.enum(SIGNATURE_STYLES) });
/** La imagen de la firma: PNG (mejor con fondo transparente) o JPG, hasta 300 KB. */
export const SIGNATURE_IMAGE_MAX_BYTES = 300 * 1024;
export const signatureImageUploadSchema = z.object({
    fileName: z.string().min(1).max(200),
    /** PNG o JPEG en base64 (sin el prefijo data:). */
    base64: z.string().min(1).max(Math.ceil((SIGNATURE_IMAGE_MAX_BYTES * 4) / 3) + 8),
});
//# sourceMappingURL=profile.js.map